<template>
  <div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
		<loginRegister ref="loginRegister"></loginRegister>
  </div>
</template>

<script>
import loginRegister from '@/components/loginRegister/loginRegister';
import { mapActions,mapState,mapMutations } from "vuex";
export default {
  name: 'app',
	components:{
		loginRegister
	},
	data() {
		return {
			userinfo: null
		}
	},
	computed:{
		...mapState({
			users:(state)=>state.login.userinfo,
		}),
	},
	created(){
		this.userinfo = this.users?this.users:""
		
	},
	mounted(){
		console.log('check wx follow',this.userinfo)
		// this.$nextTick(function () {
		// 	window.addEventListener('scroll', this.onScroll)
		// })
		
		if(this.userinfo && this.userinfo.is_follow==0){
			this.$refs['loginRegister'].login_type = 3
			this.$refs['loginRegister'].is_login = true
			this.$refs['loginRegister'].getLoginCode(this.userinfo.mobile,true)
		}
		
	},
	methods: {}
}
</script>

<style>
    svg{display: inline-block !important;}
</style>
